export const retracementColors = [
  'rgba(128, 128, 128, 1)',
  'rgba(242, 54, 69, 1)',
  'rgba(255, 152, 0, 1)',
  'rgba(76, 175, 80, 1)',
  'rgba(8, 153, 129, 1)',
  'rgba(0, 188, 212, 1)',
  'rgba(120, 123, 134, 1)',
  'rgba(41, 98, 255, 1)',
  'rgba(242, 54, 69, 1)',
  'rgba(156, 39, 176, 1)',
  'rgba(233, 30, 99, 1)',
  'rgba(255, 152, 0, 1)',
  'rgba(242, 54, 69, 1)',
  'rgba(255, 152, 0, 1)',
  'rgba(76, 175, 80, 1)',
  'rgba(8, 153, 129, 1)',
  'rgba(0, 188, 212, 1)',
  'rgba(128, 128, 128, 1)',
  'rgba(41, 98, 255, 1)',
  'rgba(242, 54, 69, 1)',
  'rgba(156, 39, 176, 1)',
  'rgba(233, 30, 99, 1)',
  'rgba(255, 152, 0, 1)',
  'rgba(8, 153, 129, 1)',
];

export const fanColors = [
  'rgba(255, 152, 0, 1)',
  'rgba(8, 153, 129, 1)',
  'rgba(76, 175, 80, 1)',
  'rgba(8, 153, 129, 1)',
  'rgba(0, 188, 212, 1)',
  'rgba(41, 98, 255, 1)',
  'rgba(156, 39, 176, 1)',
  'rgba(233, 30, 99, 1)',
  'rgba(242, 54, 69, 1)',
];

export const channelColors = [
  'rgba(128, 128, 128, 1)',
  'rgba(255, 152, 0, 1)',
  'rgba(0, 188, 212, 1)',
  'rgba(76, 175, 80, 1)',
  'rgba(8, 153, 129, 1)',
  'rgba(41, 98, 255, 1)',
  'rgba(128, 128, 128, 1)',
];

const levelsPropety = [
  { show: true, value: 0 },
  { show: true, value: 0.25 },
  { show: true, value: 0.382 },
  { show: true, value: 0.5 },
  { show: true, value: 0.618 },
  { show: true, value: 0.75 },
  { show: true, value: 1 },
];

const defaultRetracements = [
  { show: true, value: 0 },
  { show: true, value: 0.236 },
  { show: true, value: 0.382 },
  { show: true, value: 0.5 },
  { show: true, value: 0.618 },
  { show: true, value: 0.786 },
  { show: true, value: 1 },
  { show: true, value: 1.618 },
  { show: false, value: 2.618 },
  { show: false, value: 3.618 },
  { show: false, value: 4.236 },
  { show: false, value: 1.272 },
  { show: false, value: 1.414 },
  { show: false, value: 2.272 },
  { show: false, value: 2.414 },
  { show: false, value: 2 },
  { show: false, value: 3 },
  { show: false, value: 3.272 },
  { show: false, value: 3.414 },
  { show: false, value: 4 },
  { show: false, value: 4.272 },
  { show: false, value: 4.414 },
  { show: false, value: 4.618 },
  { show: false, value: 4.764 },
];

const defaultGannFans = [
  { show: true, value: '1x8' },
  { show: true, value: '1x4' },
  { show: true, value: '1x3' },
  { show: true, value: '1x2' },
  { show: true, value: '1x1' },
  { show: true, value: '2x1' },
  { show: true, value: '3x1' },
  { show: true, value: '4x1' },
  { show: true, value: '8x1' },
];

// Dynamically assign colors from defaultLevelsColor to levels
export const levelsPropetyWithColor = levelsPropety.map((level, index) => ({
  ...level,
  color: channelColors[index],
}));

export const retracementsPropetyWithColor = defaultRetracements.map((level, index) => ({
  ...level,
  color: retracementColors[index],
}));

export const fansWithColor = defaultGannFans.map((level, index) => ({
  show: level.show,
  value: level.value,
  color: fanColors[index],
}));
